export default function scheduleworkhours(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                scheduleworkhour: action.scheduleworkhour,
            }
        default:
            return state;
    }
}
